<template>
  <div class="itemDetailHeader" itemtype="http://schema.org/Product" itemscope>
    <meta itemprop="mpn" :content="item.item_id" />
    <meta itemprop="name" :content="item.item_name" />
    <meta itemprop="description" :content="item.detailed_explanation"  />
    <link itemprop="image" :href="item.pack_image" />
    <div v-if="this.selectedData" class="itemDetailHeader__body">
      <div class="leftbox" v-if="hasImage">
        <div class="media__image" data-clip-path-support="true">
          <uranai-img data-clip-path-support="true" data-size="lg" size="lg" :src="item.pack_image"></uranai-img>
        </div>
      </div>

      <div class="rightbox_container">
        <div :class="['rightbox',{'has_noimage':!hasImage}]">
          <div class="word">
            <span class="is_new" v-if="isNew && !isSubscPresent">NEW</span>
            <p class="word__text">{{item.item_name}}</p>
          </div>
          <div class="tagarea" v-if="!isSubscPresent">
            <span class="badge">{{item.service_type_str}}</span>
            <span class="badge u-tag" v-if="item.category_tag_name">{{item.category_tag_name}}</span>
          </div>
          <div class="rows" itemprop="offers" itemtype="http://schema.org/Offer" itemscope>
              <link itemprop="url" v-bind:href="'/contents/' + ( '000000' +  item.item_id ).slice( -6 )  + '/detail'" />
              <link itemprop="availability" href="http://schema.org/OnlineOnly" />
              <meta itemprop="priceCurrency" content="JPY" />
              <meta itemprop="itemCondition" content="https://schema.org/UsedCondition" />
              <meta itemprop="price" :content="item.price_taxin " />
            <div class="price" v-if="!isSubscPresent">
              <span  class="price__value">¥{{item.price_taxin | addComma }}</span>
              <span class="price__tax">（税込）</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-loading class="u-mg-center" :is-loading="true" v-else></app-loading>
     <div itemprop="brand" itemtype="http://schema.org/Thing" itemscope>
        <meta itemprop="name" content="AGARUTV" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'

export default {
  name: 'item-detail-header',
  data() {
    return {
      selectedData: false
    }
  },
  props: {
    itemId: { type: String, default: '' },
    itemType: { type: String, default: '占い' },
    hasImage: { type: Boolean, default: true },
    isNew: { type: Boolean, default: false},
    isSubscPresent: {type: Boolean, default: false}
  },
  computed: {
    ...mapState({
      item: state => state.item.selected
    })
  },
  mounted() {
    this.$store.dispatch(type.RESET_SELECTED_ITEM)
    this.$store.dispatch(type.SELECT_ITEM, { id: parseInt(this.itemId, 10) }).then(() => {
      this.selectedData = true
    })
  }
}
</script>

<style lang="scss">
.itemDetailHeader {
  &__body {
    display: flex;
    width: 100%;
  }

  .rightbox_container {
    display: table-cell;
    width: 100%;
  }

  .rightbox {
    display: table;
    height: auto;
    min-height: 125px;
    width: 100%;

    &.has_noimage {
      min-height: 74px;
    }

    .word {
      .is_new {
        color: #ed1e79;
        line-height: 19px;
        font-size: 11px;
        font-weight: bold;
        margin-right: 0.2em;
        float: left;
      }

      &__text {
        margin: 0;
        font-size: 15px;
        line-height: 19px;
        color: #000000;
      }

    }



    .rows {
      display: table-row-group;

      .price {
        color: #ed1e79;
        text-align: right;
        line-height: 16px;
        font-size: 20px;
        font-weight: bold;

        &__value {
          margin-right: -0.6em;
        }

        &__tax {
          font-size: 14px;
          margin-right: -0.5em;
        }
      }
    }
  }

  &.disabled {
    opacity: 0.4;

    .rightbox .rows .price {
      color: #aaaaaa;
    }
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ItemDetailHeader.vue